<template>
  <v-flex
    xs12
    sm6
  >
    <p class="fw-600 f-1 required-block mb-0 mt-3">
      2. {{ $t('warehouses.locationData.warehouse_address') }}
    </p>
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <v-text-field
          v-model="locationName"
          v-validate="validationRules.get('regular_field_max_180')"
          :label="$t('warehouses.locationData.location_name')"
          single-line
          :error-messages="errors.collect('locationName')"
          :data-vv-as="' '"
          :data-vv-name="'locationName'"
          auto-grow
          :disabled="readOnly"
          @blur="emitData()"
        />
      </v-flex>
      <v-flex xs12>
        <v-text-field
          v-if="street !== false"
          v-model="street"
          v-validate="validationRules.get('required_field_max_180')"
          :label="$t('label.street')"
          class="required-field"
          single-line
          :error-messages="errors.collect('street')"
          :data-vv-as="' '"
          :data-vv-name="'street'"
          required
          auto-grow
          :disabled="readOnly"
          @blur="emitData()"
        />
        <v-checkbox
          v-model="street"
          :class="street === false ? '' : 'mt-0 pt-0'"
          :false-value="null"
          :true-value="false"
          :label="$t('message.location_no_street')"
          data-vv-name="no_flat_number"
          type="checkbox"
          off-icon=""
          :disabled="readOnly"
          on-icon="check"
        />
      </v-flex>
      <v-layout
        row
        justify-space-between
      >
        <v-flex xs5>
          <v-text-field
            v-model="placeNumber"
            v-validate="validationRules.get('building_number')"
            :label="$t('label.building_number')"
            single-line
            class="required-field"
            :error-messages="errors.collect('place_number')"
            :data-vv-as="' '"
            :data-vv-name="'place_number'"
            required
            auto-grow
            :disabled="readOnly"
            @blur="emitData()"
          />
        </v-flex>
        <v-flex xs5>
          <v-text-field
            v-model="flatNumber"
            v-validate="validationRules.get('flat_number')"
            :label="$t('label.place_number')"
            single-line
            :error-messages="errors.collect('flatNumber')"
            :data-vv-as="' '"
            :data-vv-name="'flatNumber'"
            auto-grow
            :disabled="readOnly"
            @blur="emitData()"
          />
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <v-text-field
          v-model="postalCode"
          v-validate="validationRules.get('postal_code')"
          :label="$t('label.postal_code')"
          single-line
          class="required-field"
          mask="##-###"
          :error-messages="errors.collect('postal_code')"
          :data-vv-as="' '"
          :data-vv-name="'postal_code'"
          required
          auto-grow
          :disabled="readOnly"
          inputmode="numeric"
          @blur="emitData()"
        />
      </v-flex>
      <v-flex xs12>
        <v-text-field
          v-model="city"
          v-validate="validationRules.get('warehouseCity')"
          :label="$t('label.city_2')"
          single-line
          class="required-field"
          :error-messages="errors.collect('city')"
          :data-vv-as="' '"
          :data-vv-name="'city'"
          required
          auto-grow
          :disabled="readOnly"
          @blur="emitData()"
        />
      </v-flex>
      <v-flex
        xs12
        mt-2
      >
        <v-text-field
          v-model="selectedProvince.name"
          v-validate="validationRules.get('province')"
          :label="$t('label.province')"
          :error-messages="errors.collect('province')"
          :data-vv-as="' '"
          :data-vv-name="'province'"
          required
          auto-grow
          disabled
        />
      </v-flex>
      <v-flex
        v-if="warehouseType === 1"
        xs12
        mt-2
      >
        <v-text-field
          v-model="selectedRejon.name"
          v-validate="validationRules.get('required_regular_field')"
          :label="$t('label.area')"
          :error-messages="errors.collect('rejon')"
          :data-vv-as="' '"
          :data-vv-name="'rejon'"
          required
          auto-grow
          disabled
        />
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import validationRules from '@/constants/validationRules';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'warehouses/getAddress',
    mutationType: 'warehouses/updateAddress'
});

export default {
    name: 'WarehouseAddress',
    inject: ['$validator'],
    props: {
        warehouseType: {
            required: true,
            type: Number
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            validationRules
        };
    },
    computed: {
        ...mapFields([
            'locationName',
            'street',
            'city',
            'flatNumber',
            'placeNumber',
            'province',
            'rejon',
            'postalCode'
        ]),
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        selectedProvince () {
            return this.$store.getters['warehouses/getSelectedProvince'];
        },
        selectedRejon () {
            return this.$store.getters['warehouses/getSelectedRejon'];
        }
    },
    watch: {
        street: {
            handler (val) {
                if (val === false || val === null) {
                    this.emitData();
                }
            },
            immediate: true
        }
    },
    created () {
        this.province = this.selectedProvince.province_id;
        if (this.warehouseType === 1) {
            this.rejon = this.selectedRejon.id;
        }
    },
    methods: {
        emitData () {
            const address = {
                locationName: this.locationName,
                street: this.street,
                city: this.city,
                flatNumber: this.flatNumber,
                placeNumber: this.placeNumber,
                province: this.province,
                rejon: this.rejon,
                postalCode: this.postalCode
            };
            this.$emit('emitAddress', address);
        }
    }
};
</script>

<style scoped></style>
